import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import LdsImage from "../../components/LdsImage";
import AlzheimerPhoto from "../../assets/module-1/alzheimer-photo.png";
import References from "../../components/References/index.jsx";

import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_0_2 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <div className="">
            <section className="mb-5 container">
              <h1 className="blue text-uppercase b mt-5">
                1.0.2 BRIEF HISTORY OF AMYLOID
              </h1>
              <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
            </section>
            <section className="row">
              <div className="col">
                <LdsImage
                  src={AlzheimerPhoto}
                  style={{ maxWidth: "700px" }}
                  alt="Black and white photograph of a man wearing glasses, a suit, and a tie, seated with hands folded in his lap."
                  className="justify-content-center"
                />
              </div>
              <div className="col">
                <p>
                  In 1906, a clinical psychiatrist and neuroanatomist, Dr. Alois
                  Alzheimer, reported “a peculiar, severe disease process of the
                  cerebral cortex” in a female patient, Auguste D.<sup>1</sup>
                </p>
                <p>
                  Upon autopsy, Dr. Alzheimer observed that the patient's brain was atrophied<sup>2</sup>; staining the tissue with a silver-containing dye revealed it to be studded with abnormal clumps and fiber bundles, later known as beta-amyloid neuritic plaques and neurofibrillary tau tangles.<sup>1,3,4</sup>
                </p>
                <p>
                  In 1984, Dr. George G. Glenner and colleagues proposed that accumulating beta-amyloid in the brain may have a causative role in AD; this was initially met with skepticism, but today is one of the leading hypotheses.<sup>5</sup>
                </p>
              </div>
            </section>
            <section className="button-control">
              <LdsButton
                classes="white-button mt-3 mb-5 prev"
                onClick={function navClick() {
                  window.open("/module-1/module-1-0-1", "_self");
                }}
              >
                Previous Lesson
              </LdsButton>
              <LdsButton
                classes="blue-button mt-3 mb-5 align-self-right float-end next"
                onClick={function navClick() {
                  window.open("/module-1/module-1-0-3", "_self");
                }}
              >
                Next Lesson
              </LdsButton>
            </section>

            <References>
              <ol className="no-indent fz-sm">
                <li>Hippius H, Neundörfer G. <em>Dialogues Clin Neurosci.</em> 2003;5(1):101-108.</li>
                <li>O’Brien C. <em>Science.</em> 1996;273:5271.</li>
                <li>NIH. Alzheimer's disease fact sheet. Accessed February 23, 2024. https://www.nia.nih.gov/health/alzheimers-and-dementia/alzheimers-disease-fact-sheet.</li>
                <li>
                  Jack CR, Jr., et al. <em>Lancet Neurol.</em> 2013;12(2):207-216.
                </li>
                <li>
                  Selkoe DJ, Hardy J. <em>EMBO Mol Med.</em> 2016;8(6):595-608.
                </li>
              </ol>
            </References>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Module_1_0_2;
